// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"e27cac75","389":"bfe33945","406":"03e79ee4","695":"d7901a39","702":"c47137e4"}[chunkId] + ".chunk.js";
};